import { extend } from 'vee-validate'
import { required, email, max, min } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'The {_field_} can not be empty.'
})

extend('max', {
  ...max,
  message: 'The {_field_} may not be greater than {length} characters.'
})

extend('min', {
  ...min,
  message: 'The {_field_} must be at least {length} characters.'
})

extend('email', {
  ...email,
  message: 'The {_field_} must be a valid email address.'
})
